import { render, staticRenderFns } from "./auditAffiliateWithdrawal.vue?vue&type=template&id=4079d30c"
import script from "./auditAffiliateWithdrawal.vue?vue&type=script&lang=js"
export * from "./auditAffiliateWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports